import { Routes } from '@angular/router';
import { unitResolver } from './core/resolvers/unit.resolver';
import { checkoutGuard } from './core/guards/checkout.guard';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth/set-password',
    loadComponent: () =>
      import('./features/account/pages/set-password/set-password.component').then(
        (m) => m.SetPasswordComponent
      ),
  },
  {
    path: 'auth/forgot-password',
    loadComponent: () =>
      import('./features/account/pages/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    // Partner group restaurant picker. Public, and outside the unit layout on
    // purpose: there is no unit yet, so unitResolver must not run here.
    path: 'g/:groupSlug',
    loadComponent: () =>
      import('./features/partner/pages/partner-landing/partner-landing.component').then(
        (m) => m.PartnerLandingComponent
      ),
  },
  {
    path: 'u/:routeName',
    resolve: { unitData: unitResolver },
    loadComponent: () =>
      import('./layout/components/app-layout/app-layout.component').then(
        (m) => m.AppLayoutComponent
      ),
    children: [
      {
        path: 'checkout',
        canActivate: [checkoutGuard],
        loadChildren: () => import('./features/checkout/checkout.routes').then(m => m.routes)
      },
      {
        path: 'products/:id',
        loadComponent: () =>
          import('./features/product/pages/product/product.component').then(
            (m) => m.ProductComponent
          ),
      },
      {
        path: 'account',
        canActivate: [authGuard],
        loadChildren: () => import('./features/account/account.routes').then(m => m.routes)
      },
      {
        path: '',
        loadChildren: () => import('./features/home/home.routes').then(m => m.routes)
      },
    ]
  },
  {
    path: 'success',
    loadComponent: () =>
      import('./features/success/page/success-page/success-page.component').then(
        (m) => m.SuccessPageComponent
      ),
  },
  {
    path: 'failure',
    loadComponent: () =>
      import('./features/failure/page/failure-page/failure-page.component').then(
        (m) => m.FailurePageComponent
      ),
  }
];
